var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonEndRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 38
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 37l9.21-9.21V10L0 1V0h.41l9.8 9.79v18.42L.41 38H0z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ButtonEndRight_svg__fill-on-hover",
    d: "M0 37l9.21-9.21V10L0 1z",
    fill: "transparent"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIzOCIgdmlld0JveD0iMCAwIDEwIDM4Ij4KPHBhdGggZD0iTTAsMzdsOS4yMS05LjIxVjEwTDAsMVYwSC40MWw5LjgsOS43OVYyOC4yMUwuNDEsMzhIMFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBjbGFzcz0iZmlsbC1vbi1ob3ZlciIgZD0iTTAsMzdsOS4yMS05LjIxVjEwTDAsMVoiIGZpbGw9InRyYW5zcGFyZW50IiAvPgo8L3N2Zz4=";
export { SvgButtonEndRight as ReactComponent };